import styled from "styled-components";
import GlobalStyle from "../../../GlobalStyle";

const Button = (props) => {
  return (
    <>
      <GlobalStyle />
      <Btn {...props} secondary={props.secondary} onClick={props.onClick}>
        {props.value}
      </Btn>
    </>
  );
};

Button.defaultProps = {
  secondary: false,
};
export default Button;

const Btn = styled.button`
  border-radius: 8px;
  background-color: ${(props) => (props.secondary ? "#fff" : "#27CE0A")};
  color: ${(props) => (props.secondary ? "#27CE0A" : "#fff")};
  font-size: 16px;
  font-weight: 700;
  padding: 5px 18px;
  line-height: 26px;
  border: 1px solid ${(props) => (props.secondary ? "#27CE0A" : "#fff")};
  font-family: "helveticaneuebold";
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 6px;
    font-size: 12px;
    padding: 2px 8px;
    font-weight: normal;
    font-family: "helvetica_neuemedium_extended";
  }
  &:active,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 50%);
  }
  ${(props) =>
    props.isLoading
      ? `
      opacity: 0.5;
      pointer-events: none;
    `
      : ""}
  ${(props) =>
    props.isDisabled
      ? `
      opacity: 0.5;
      pointer-events: none;
    `
      : ""}
`;
